import { RegulatoryReportsPage } from "@nvb/ui";
import { usePageContext } from "vike-react/usePageContext";

import type { IDocumentsApiResponse } from "@nvb/ui";

/** See `pages/about/legal-and-regulatory/regulation/+Page.tsx` for the why. */
export default function Page() {
	const { initialData } = usePageContext();
	const documents = initialData?.documents as IDocumentsApiResponse | undefined;

	return <RegulatoryReportsPage {...(documents ? { initialDocuments: documents } : {})} />;
}
